export const dashToPascalCase = (str) => str
    .toLowerCase()
    .split('-')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');
export const isEventProp = (propName) => {
    return propName.indexOf('on') === 0 && propName[2] === propName[2].toUpperCase();
};
export const normalizeEventPropName = (propName) => {
    return `on${propName[2].toLowerCase()}${propName.substring(3)}`;
};
